import { useEffect, useState } from 'react';

const Countdown = ({ value, onFinish, format = 'HH:mm:ss', style = {} }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    // Calculate initial time difference in milliseconds
    const now = Date.now();
    const targetTime = typeof value === 'number' ? value : new Date(value).getTime();
    const difference = targetTime - now;

    setTimeLeft(difference > 0 ? difference : 0);

    // Set up interval to update countdown
    const interval = setInterval(() => {
      const now = Date.now();
      const difference = targetTime - now;

      if (difference <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
        if (onFinish) {
          onFinish();
        }
      } else {
        setTimeLeft(difference);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [value, onFinish]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (num) => String(num).padStart(2, '0');

    if (format === 'HH:mm:ss') {
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    } else if (format === 'mm:ss') {
      return `${pad(minutes)}:${pad(seconds)}`;
    } else if (format === 'ss') {
      return `${pad(seconds)}`;
    }

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  return <span style={style}>{formatTime(timeLeft)}</span>;
};

export default Countdown;
